module.exports = __webpack_public_path__ + "static/media/10_1_CAM.e97fa9e6.png";